module.exports = __webpack_public_path__ + "static/media/favicon_swisscom.3879541f.ico";